var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#082244","fillRule":"evenodd","d":"M43.219 25.8494C44.2603 24.828 44.2603 23.172 43.219 22.1506L28.5523 7.76603C27.5109 6.74466 25.8224 6.74466 24.781 7.76603C23.7397 8.7874 23.7397 10.4434 24.781 11.4647L37.5621 24L24.781 36.5353C23.7397 37.5566 23.7397 39.2126 24.781 40.234C25.8224 41.2553 27.5109 41.2553 28.5523 40.234L43.219 25.8494Z","clipRule":"evenodd","className":"color082244 svgShape","key":0}),React.createElement("path",{"fill":"#082244","fillRule":"evenodd","d":"M4 24C4 25.6684 5.17807 27 6.63129 27H38.3687C39.8108 27 41 25.6569 41 24C41 22.3316 39.8219 21 38.3687 21H6.63129C5.18915 21 4 22.3431 4 24Z","clipRule":"evenodd","className":"color082244 svgShape","key":1})]);
}

ArrowRight.defaultProps = {"width":"12","height":"11","viewBox":"0 0 12 12","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
